<section>
  <content-viewer
    *ngIf="body"
    [content]="body"
    (docRendered)="handleDocRendered($event)">
  </content-viewer>
  <div class="left-contact-panel">
    <contact-block class="left-contact-block"></contact-block>
  </div>
  <app-lead-gen [product]="productName"></app-lead-gen>
</section>
<section>
  <contact-block class="right-contact-block"></contact-block>
</section>
